import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { MeDto, OnboardingInput } from '@zoxo/shared';

import { api } from '../../lib/api';

/**
 * Company-name onboarding (POST /users/me/onboarding, AC-0.3/0.4). The server
 * normalizes the raw name and derives initials; the client submits the
 * raw name and shows a live initials preview separately (toCompanyInitials).
 *
 * Plain mutation. On success the returned MeDto (onboarded: true) is written
 * straight into the ['me'] cache so the onboarding gate clears immediately.
 */
export function useOnboarding() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: OnboardingInput) =>
      api.post<MeDto>('/users/me/onboarding', input),
    onSuccess: (me) => {
      queryClient.setQueryData(['me'], me);
    },
  });
}
